/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftTrackersMetadataBatchItem } from './NftTrackersMetadataBatchItem';
import {
    NftTrackersMetadataBatchItemFromJSON,
    NftTrackersMetadataBatchItemFromJSONTyped,
    NftTrackersMetadataBatchItemToJSON,
    NftTrackersMetadataBatchItemToJSONTyped,
} from './NftTrackersMetadataBatchItem';

/**
 * 
 * @export
 * @interface NftTrackersMetadataBatchResponse
 */
export interface NftTrackersMetadataBatchResponse {
    /**
     * 
     * @type {Array<NftTrackersMetadataBatchItem>}
     * @memberof NftTrackersMetadataBatchResponse
     */
    items: Array<NftTrackersMetadataBatchItem>;
}

/**
 * Check if a given object implements the NftTrackersMetadataBatchResponse interface.
 */
export function instanceOfNftTrackersMetadataBatchResponse(value: object): value is NftTrackersMetadataBatchResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function NftTrackersMetadataBatchResponseFromJSON(json: any): NftTrackersMetadataBatchResponse {
    return NftTrackersMetadataBatchResponseFromJSONTyped(json, false);
}

export function NftTrackersMetadataBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftTrackersMetadataBatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(NftTrackersMetadataBatchItemFromJSON)),
    };
}

export function NftTrackersMetadataBatchResponseToJSON(json: any): NftTrackersMetadataBatchResponse {
    return NftTrackersMetadataBatchResponseToJSONTyped(json, false);
}

export function NftTrackersMetadataBatchResponseToJSONTyped(value?: NftTrackersMetadataBatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(NftTrackersMetadataBatchItemToJSON)),
    };
}

